import httpClient, { handleSuccess, handleError } from './httpClient'

export function info(token, referrer) {
  const params = new URLSearchParams()
  // リファラにhttps?://やlocalhostが含まれると403エラーになるので外す
  params.append('token', token)
  params.append('referrer', referrer.replace(/localhost(:\d*|)/g, '').replace(/https?:\/\//g, ''))

  return httpClient
    .get('view/info', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export function downloadFile(achievementFileid, portofolioId) {
  const params = new URLSearchParams()
  params.append('achievement_file_id', achievementFileid)
  params.append('portofolio_id', portofolioId)

  return httpClient
    .get('view/download_file', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}
